export default __webpack_public_path__ + "static/media/122.100f9ddb.webp";